import React, { createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { PromiseSection } from './components/PromiseSection';
import { WhyTraditionalFails } from './components/WhyTraditionalFails';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatIncludes } from './components/WhatIncludes';
import { MaterialPreview } from './components/MaterialPreview';
import { BonusSection } from './components/BonusSection';
import { ForWhomSection } from './components/ForWhomSection';
import { HowToStart } from './components/HowToStart';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalClose } from './components/FinalClose';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel — runs once at module load, outside React lifecycle
if (!(window as any).__fbPixelLoaded) {
  ;
  (window as any).__fbPixelLoaded = true;
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1589872922260265');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1589872922260265&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
}
export function App() {
  return <main className="min-h-screen w-full bg-white font-sans antialiased" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <WhyTraditionalFails data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatIncludes data-id="element-6" />
      <MaterialPreview data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ForWhomSection data-id="element-9" />
      <HowToStart data-id="element-10" />
      <OfferSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FAQSection data-id="element-14" />
      <FinalClose data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </main>;
}